
export const FORMATTING_INSTRUCTIONS = `

IMPORTANT FORMATTING REQUIREMENTS:
- Use clean, professional text formatting without ANY markdown symbols
- Do NOT use **, *, #, ##, ###, #### or any other markdown formatting
- Structure your response with clear numbered sections using this exact format:
  SECTION 1: ANALYSIS TITLE
  SECTION 2: NEXT ANALYSIS
- Use simple text formatting with proper paragraph breaks
- Format lists with simple dashes (-) or numbers (1., 2., 3.)
- Do NOT use bullet points with asterisks (*)
- Separate sections with clear headers using plain text only
- Write in a professional report style suitable for executive review
- Use UPPERCASE for main section headers
- Use sentence case for subsection headers

Example correct format:
SECTION 1: POLITICAL NARRATIVE MAPPING

The dominant political narratives include fiscal responsibility concerns and union advocacy for worker rights.

Key findings:
1. Government narrative focuses on budget constraints
2. Union narrative emphasizes worker value
3. Public opinion remains divided

Subsection Analysis:
Government positioning relies on economic data while union arguments center on service quality.

SECTION 2: STAKEHOLDER POWER ANALYSIS

Continue with clear, structured content using the same format.

NEVER use markdown symbols like **, *, #, ##, ###, #### in your response.

`;
